import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { NoDataMessage } from "@/components/atoms";
import { todoApi } from "@/shared/apis";
import { isABroker } from "@/shared/hooks";

import ToDosCard from "../components/ToDosCard/ToDosCard";
import { StyledTodoPanel } from "./styled";

export const TodoPanel: FC = () => {
    const { t } = useTranslation();
    const { data: todos = [] } = useQuery("todos", () => todoApi.getToDos());

    if (!todos.length) {
        return <NoDataMessage>{t("ToDo.Empty")}</NoDataMessage>;
    }

    return (
        <>
            <StyledTodoPanel $disabled={isABroker()} title={`${isABroker() ? t("Common.PreviewUserNotAllowed") : ""}`}>
                {todos.map((todo) => {
                    return <ToDosCard key={`todo-${todo.toDoType.id}`} toDo={todo} disabled={isABroker()} />;
                })}
            </StyledTodoPanel>
        </>
    );
};

export default TodoPanel;
